import React, { useState } from 'react';
import Input from '../ui/Input';
import Button from '../ui/Button';

const AddStudent = ({ setStudents }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');

    const handleAddStudent = (e) => {
        e.preventDefault();
        const newStudent = { id: Date.now(), name, email };
        setStudents(prevStudents => [...prevStudents, newStudent]);
        setName('');
        setEmail('');
    };

    return (
        <form onSubmit={handleAddStudent} className="mb-6">
            <h4 className="text-lg font-semibold mb-2">Add New Student</h4>
            <div className="flex flex-col space-y-2">
                <Input type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
                <Input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                <Button type="submit">Add Student</Button>
            </div>
        </form>
    );
};

export default AddStudent;
